/**
 * Divisions are created by organizers or administrators and one must be chosen when
 * creating an EventEntry.
 */
import Model, { ModelErrors } from "./Model";
import EventEntryModel from "./EventEntryModel";
import { DateTime as LuxonDatetime } from "luxon";

export interface DivisionData {
  id?: number;
  title: string;
  private: boolean;
  min_age: number;
  max_age: number;
  gender: string;
  type: string;
  fixed_price: boolean;
  skip_uploads: boolean;
  minimum_price: number;
  recommended_price: number;
  is_free: boolean;
}

export default class DivisionModel extends Model<DivisionData> {

  defaults(): DivisionData {
    return {
      title: "",
      private: false,
      min_age: 0,
      max_age: 0,
      gender: "",
      type: "",
      fixed_price: false,
      skip_uploads: false,
      minimum_price: 0,
      recommended_price: 0,
      is_free: false,
    };
  }

  isEligible(e: {age: number, gender: string}): boolean {

    if (!this.isEligibleAge(e.age)) {
      return false;
    }

    if (!this.isEligibleGender(e.gender ?? '')) {
      return false;
    }

    return true;
  }

  isEligibleAge(age: number): boolean {
    if (this.data.min_age > 0 && this.data.min_age > age) {
      return false;
    }

    if (this.data.max_age > 0 && this.data.max_age < age) {
      return false;
    }

    return true;
  }

  isEligibleGender(gender: string): boolean {
    // gender doesn't matter for this division
    if (['', 'both'].indexOf(this.data.gender) > -1) {
      return true;
    }

    if (gender !== this.data.gender) {
      return false;
    }

    return true;
  }

  getTitleLabel(): string {
    let title = this.data.title;
    // Append division type to title if not present in title
    if (this.data.type && title.indexOf(this.data.type) === -1) {
      title += ' (' + this.data.type + ')';
    }
    return title;
  }

  amountCoversCost(n: number): boolean {
    if (n === this.data.recommended_price) {
      return true;
    }

    return false;
  }
}

export function create(data?: DivisionData, errors?: ModelErrors): DivisionModel {
  return new DivisionModel(data, errors);
}
